import React from 'react';
import styles from './styles.scss';
import classNames from 'classnames/bind';
import Link from 'Components/Link';

const cx = classNames.bind(styles);

const items = [
  { name: 'zur Hauptnavigation', hash: 'header-bar' },
  { name: 'zum Hauptinhalt', hash: 'main-content' },
  { name: 'zu den Kontaktinformationen', hash: 'footer' },
  { name: 'zu den rechtlichen Angaben', hash: 'footer-legal' },
];
export default class BypassBlock extends React.Component {
  render() {
    return (
      <ol className={cx('bypassblock')}>
        {items.map((item, itemIndex) => (
          <li key={itemIndex}>
            <Link to={`#${item.hash}`} label={item.name} />
          </li>
        ))}
      </ol>
    );
  }
}
